<template>
  <div class="hello">
    <div class="lottie_container" style="opacity: 0;">
      <lottie
        :options="animationWave"
        :height="200"
        v-on:animCreated="handleAnimation"
      />
    </div>
    <h1>{{ msg }}</h1>
    <h1 id="h1-med">Coming Soon</h1>
    <!--
        <p>
        For a guide and recipes on how to configure / customize this project,<br />
        check out the
        <a href="https://cli.vuejs.org" target="_blank" rel="noopener"
          >vue-cli documentation</a
        >.
      </p>
      <h3>Installed CLI Plugins</h3>
      <ul>
        <li>
          <a
            href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel"
            target="_blank"
            rel="noopener"
            >babel</a
          >
        </li>
        <li>
          <a
            href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint"
            target="_blank"
            rel="noopener"
            >eslint</a
          >
        </li>
      </ul>
      <h3>Essential Links</h3>
      <ul>
        <li>
          <a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a>
        </li>
        <li>
          <a href="https://forum.vuejs.org" target="_blank" rel="noopener"
            >Forum</a
          >
        </li>
        <li>
          <a href="https://chat.vuejs.org" target="_blank" rel="noopener"
            >Community Chat</a
          >
        </li>
        <li>
          <a href="https://twitter.com/vuejs" target="_blank" rel="noopener"
            >Twitter</a
          >
        </li>
        <li>
          <a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a>
        </li>
      </ul>
      <h3>Ecosystem</h3>
      <ul>
        <li>
          <a href="https://router.vuejs.org" target="_blank" rel="noopener"
            >vue-router</a
          >
        </li>
        <li>
          <a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a>
        </li>
        <li>
          <a
            href="https://github.com/vuejs/vue-devtools#vue-devtools"
            target="_blank"
            rel="noopener"
            >vue-devtools</a
          >
        </li>
        <li>
          <a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener"
            >vue-loader</a
          >
        </li>
        <li>
          <a
            href="https://github.com/vuejs/awesome-vue"
            target="_blank"
            rel="noopener"
            >awesome-vue</a
          >
        </li>
      </ul> 
    -->
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData_Wave from "../assets/anim/anim_100.json";
import anime from "animejs";

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    lottie: Lottie
  },
  mounted() {
    // animejs animation configuration.
    anime({
      targets: "h1",
      direction: "linear",
      translateY: -15,
      opacity: 1,
      easing: "easeOutSine",
      duration: 1500
    });
    anime({
      targets: [".lottie_container"],
      direction: "linear",
      translateY: 15,
      opacity: 1,
      easing: "easeInSine",
      duration: 1000
    });
  },
  data() {
    return {
      animationWave: { animationData: animationData_Wave.default },
      animationSpeed: 0.5
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },

    stop: function() {
      this.anim.stop();
    },

    play: function() {
      this.anim.play();
    },

    pause: function() {
      this.anim.pause();
    },

    onSpeedChange: function() {
      this.anim.setSpeed(this.animationSpeed);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: "Futura PT Light";
  src: url("../assets/fonts/FuturaPT_Light.otf");
}
@font-face {
  font-family: "Futura PT Medium";
  src: url("../assets/fonts/FuturaPT-Medium.otf");
}
h1 {
  font-family: "Futura PT Light";
  font-weight: 400;
  opacity: 0;
}
#h1-med {
  font-family: "Futura PT Medium";
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
